import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./../management/input";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Askforsave from "../common/confirmSubmit";
import { toast } from "react-toastify";

const schema = yup.object({
  name: yup
    .number("yyy")
    .positive("xxxx")
    .integer("aaaa")
    .required("zzz")
    .min(0, "ค่าต่ำสุดคือ 0")
    .max(6, "over limit =>4"),
});

const Modalchip = ({
  id,
  isOpen,
  onCancel,
  onConfirm,
  list,
  header,
  label,
  limit,
}) => {
  const [dataforsave, setdataforsave] = useState({ chipsupplier: 0, name: 0 });
  const [isAskopen, setisAskopen] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });

  const handleConfirm = () => {
    setisAskopen(false);
    onConfirm(dataforsave, id);
  };
  const askcancle = () => {
    setisAskopen(false);
  };

  const onSubmit = (data) => {
    setdataforsave(data);
    setisAskopen(true);
  };

  const handleCancle = () => {
 
    onCancel(id);
  };

  useEffect(() => {
    if (!isOpen) return;
    const Cleardata = () => {
      reset({
        name: "",
      });
    };
    Cleardata();
  }, [isOpen, reset]);

  return (
    <div>
      <Askforsave
        onConfirm={handleConfirm}
        isOpen={isAskopen}
        size="xs"
        onCancel={askcancle}
        header={"ยืนยันบันทึกรายการ ใช่หรือไม่"}
        message={"ไม้ชิพรถกล่อง AA " + dataforsave.name + " คัน คิวรถบริษัท "}
        button1={"บันทึก"}
      />
      <Modal
        className="modal-dialog modal-lg"
        isOpen={isOpen}
        toggle={onCancel}
        centered
      >
        <ModalHeader className="d-flex justify-content-center ">
          <span className="bi bi-gear-fill text-primary">{header}</span>
        </ModalHeader>
        <ModalBody>
          <>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="modal-body p-0">
                <div className="card ">
                  <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-primary text-light">
                    <span
                      aria-hidden="true"
                      className="bi bi-truck me-2"
                    ></span>
                    รถบริษัท
                  </div>
                  <div className="card-body p-2  d-flex justify-content-center">
                    <div className="col-lg-6 text-center ">
                      <Input
                        icon="bi bi-book-fill text-primary me-2   "
                        label={label}
                        name="name"
                        register={register}
                        required
                        type="number"
                        errors={errors.name}
                        margin="mb-2 mt-3"
                        className="text-center mt-2"
                      />
                      <span
                        className="badge rounded-pill text-danger mb-3 mt-2"
                        style={{ fontSize: "15px" }}
                      >
                        {limit}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </>
        </ModalBody>
        <ModalFooter>
          <div className="row">
            <div className=" col-auto">
              <Button color="primary" onClick={handleSubmit(onSubmit)}>
                Confirm
              </Button>
            </div>
            <div className="  col-auto">
              <Button color="secondary" onClick={handleCancle}>
                Cancel
              </Button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modalchip;
